import React, { useContext, Fragment } from "react";
import { NavLink } from "react-router-dom";
import "../resources/global.css";
import "../resources/navbar.css";
import UserContext from "../contexts/UserContext";
import UserNavbarDropdown from "../hocs/UserNavbarDropdown";

function Navbar(props) {
  const userContext = useContext(UserContext);
  return (
    <div className="navbar">
      <div className="navbar-section">
        <NavLink to="/" exact className="navbar-item" id="navbar-home">
          Ou<span style={{ color: "var(--theme-orange)" }}>Media</span>
        </NavLink>
      </div>
      <div className="navbar-section">
        {!userContext.isLoggedIn ? (
          <Fragment>
            <NavLink to="/login" exact className="navbar-item">
              Login
            </NavLink>
            <NavLink to="/register" exact className="navbar-item">
              Register
            </NavLink>
          </Fragment>
        ) : (
          <Fragment>
            <UserNavbarDropdown/>
          </Fragment>
        )}
      </div>
    </div>
  );
}

export default Navbar;
